import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';
import { SequenceCard, type SequenceSummary } from '../outreach/SequenceCard';

// SequenceRow mirrors the schema-enforced shape (packages/widgets/src/schemas.ts
// `sequences-list` + apps/outreach-agent/src/tools/sequences-list.ts
// SequenceItemSchema). Schema validation runs at directive-parse time and
// rejects partial entries before they reach this component, so all four
// counts + trigger are guaranteed present.
type SequenceRow = {
  name: string;
  trigger: { type: string; eventName: string };
  step_count: number;
  enrollment_count: number;
  exited_count: number;
};

export function SequencesList(props: WidgetProps) {
  // The `?? []` guards the no-payload path (storybook / debug renders where
  // decodeWidgetData returns {}), NOT the schema-validated pipeline — by
  // the time a directive-borne payload reaches us its shape is already
  // validated against the strict schema in packages/widgets/src/schemas.ts.
  const sequences = (decodeWidgetData(props.payload).sequences ?? []) as SequenceRow[];

  if (sequences.length === 0) {
    return <p className="text-sm text-foreground-mute">No sequences defined.</p>;
  }

  return (
    <div className="space-y-3">
      {sequences.map((s) => {
        const summary: SequenceSummary = {
          name: s.name,
          trigger: s.trigger,
          step_count: s.step_count,
          enrollment_count: s.enrollment_count,
          exited_count: s.exited_count,
        };
        return <SequenceCard key={s.name} sequence={summary} />;
      })}
    </div>
  );
}
